export var FilterPredicate;
(function (FilterPredicate) {
    FilterPredicate[FilterPredicate["Sport"] = 0] = "Sport";
    FilterPredicate[FilterPredicate["Date"] = 1] = "Date";
    FilterPredicate[FilterPredicate["LiveStreaming"] = 2] = "LiveStreaming";
    FilterPredicate[FilterPredicate["Favorites"] = 3] = "Favorites";
})(FilterPredicate || (FilterPredicate = {}));
export var SubFilterPredicate;
(function (SubFilterPredicate) {
    SubFilterPredicate[SubFilterPredicate["None"] = 0] = "None";
    SubFilterPredicate[SubFilterPredicate["LiveStreaming"] = 1] = "LiveStreaming";
    SubFilterPredicate[SubFilterPredicate["FastMarket"] = 2] = "FastMarket";
})(SubFilterPredicate || (SubFilterPredicate = {}));
//# sourceMappingURL=FilterPredicate.js.map